export default __webpack_public_path__ + "static/media/Newsletter 026.f3c1f493.png";